import { ISearchConfig } from 'src/app/pages/_searchs/member/member-search.model';


export enum SearchCriteriaSyncOptions {
    always = 'ALWAYS',
    onFocus = 'ONFOCUS',
}

export interface IAppSearchBarConfig extends ISearchConfig {
    hideFullSearchButton?: boolean;
    zIndex?: number;
    syncOption: SearchCriteriaSyncOptions;
    inputBoxPlaceHolder?: string;
    searchResultsDisplayWindowHeight?: string;
    showErrorMessage?: boolean;
}
